import { createAuthClient } from "better-auth/react";
import { emailOTPClient, organizationClient } from "better-auth/client/plugins";
import { wrote } from "./api";

/** Better Auth's browser client, same origin, only the routes the guard leaves open (docs/auth-endpoints.md). */
/** Polish round two: every write through the library (an invitation sent or cancelled, a member removed, leaving) drops what the shared fetch
 *  layer remembers, as a write through `api` does. */
const isWrite = (method: unknown) => typeof method === "string" && method.toUpperCase() !== "GET";
export const authClient = createAuthClient({ basePath: "/api/auth", plugins: [emailOTPClient(), organizationClient()], fetchOptions: {
  onRequest: (ctx) => { if (isWrite(ctx.method)) wrote("/api/auth"); },
  onResponse: (ctx) => { if (isWrite(ctx.request.method)) wrote("/api/auth"); },
} });
